import axios from 'axios';
import { useCancellablePromise } from '../Hooks';

const USER_CREATION_URL = process.env.NODE_ENV === 'production'
? 'https://us-central1-discourse-bd58f.cloudfunctions.net/silkapi/signup'
: 'http://localhost:5001/discourse-bd58f/us-central1/silkapi/signup';


const CAPTCHA_VERIFICATION_URL = process.env.NODE_ENV === 'production'
? 'https://us-central1-discourse-bd58f.cloudfunctions.net/silkapi/verify'
: 'http://localhost:5001/discourse-bd58f/us-central1/silkapi/verify';


const QUIZ_LOGGING_URL = process.env.NODE_ENV === 'production'
  ? 'https://us-central1-discourse-bd58f.cloudfunctions.net/silkapi/logquiz'
: 'http://localhost:5001/discourse-bd58f/us-central1/silkapi/logquiz';


export const createUser = (authuser, referrer, username, email) =>
{
console.log(authuser);
console.log(authuser.user.uid);
    axios.post(USER_CREATION_URL,
        {
            uid: authuser.user.uid,
            referrer,
            username,
            email
        });
    }


export const verifyCaptcha = (captchatoken) =>
axios.post(CAPTCHA_VERIFICATION_URL,
    {
        captchatoken
    });

// export const makeCancelable = (promise) => {
//         let hasCanceled_ = false;
      
//         const wrappedPromise = new Promise((resolve, reject) => {
//           promise.then(
//             val => hasCanceled_ ? reject({isCanceled: true}) : resolve(val),
//             error => hasCanceled_ ? reject({isCanceled: true}) : reject(error)
//           );
//         });
      
//         return {
//           promise: wrappedPromise,
//           cancel() {
//             hasCanceled_ = true;
//           },
//         };
//       };   

export const logQuiz = (data, uid) =>
axios.post(QUIZ_LOGGING_URL, {
data,
uid
});
